import { create } from 'zustand'
import { isSegmentId, type SegmentId } from '../model/types'
const KEY = 'humanteq-pending-segment'
// The build's variant claims its default segment (deploy-breakup builds with
// VITE_APP_VARIANT=breakup); ?segment= links still override it per session.
let fallback: SegmentId = import.meta.env.VITE_APP_VARIANT === 'breakup' ? 'break_up' : 'humanteq'
let selectedInSession = false
export function getPendingSegment(): SegmentId {
  if (selectedInSession) return fallback
  try {
    const value = localStorage.getItem(KEY)
    return isSegmentId(value) ? value : fallback
  } catch { return fallback }
}
export const usePendingSegment = create<{ segment: SegmentId }>(() => ({ segment: getPendingSegment() }))
export function capturePendingSegment(url: URL): SegmentId {
  const values = url.searchParams.getAll('segment')
  if (values.length === 1 && isSegmentId(values[0])) {
    fallback = values[0]
    selectedInSession = true
    try { localStorage.setItem(KEY, fallback) } catch { /* session fallback */ }
  }
  const segment = getPendingSegment()
  usePendingSegment.setState({ segment })
  return segment
}
export function clearPendingSegment() {
  fallback = import.meta.env.VITE_APP_VARIANT === 'breakup' ? 'break_up' : 'humanteq'
  selectedInSession = false
  try { localStorage.removeItem(KEY) } catch { /* session fallback */ }
  usePendingSegment.setState({ segment: fallback })
}
